import React, { Component } from 'react';

import Swal from 'sweetalert2'
import instance from "./axios-instance";
import MainSettingContext from './MainSettingContext';
import { t } from './i18n';
import Systems from "./SystemFunction";
import moment from 'moment';
import jwt_decode from "jwt-decode";
import md5 from "md5";
import { toast } from 'react-toastify';
class App extends Component {
  static contextType = MainSettingContext;
  constructor(props) {
    super(props)
    this.state = {
      categorylist: [],
      rewardlist: [],
      activePage: 1,
      pagecount: 1,
      products_page_count: 1,
      isActive: false,
      activeTab: 1,
      formData: {},
      errors: {},
      formSubmitted: false,
      loading: true,
      tblprofile: props.tblprofile || [],
      userid: props.userid || null,
      linkaff: props.linkaff || "",
      point: props.point || 0,
      useradvice: [],
      balance: props.balance || 0,
      loginstate: props.loginstate || null,
      firstname: null,
      lastname: null,
      alert: null,
      modalOpen: false,
      handleClose: false,
      proderedeemlist: [],
      token: window.localStorage.getItem("token"),
      type: "",
      username: props.username || "",
      tabselect: 1,
      amount: "",
      tblwheelsetting: [],
      remark: "",
      mainacc: "",
      rankpic: props.rankpic || "1.jpeg",
      rankname: props.rankname || null,
      rankob: props.rankob || null,
      rankpoint: props.rankpoint || 0,
      remaining_amount: 0,
      name: "",
      password: "",
      left: false,
      disable: false,
      segColors: null,
      segments: null
    }
  }
  get lang() {
    return this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
  }

  logout = (e) => {

  }
  waitnotify = async () => {
  }
  async opencliaminvite(evt, cityName) {

    var token = localStorage.getItem('auth_token');
    if (token) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await instance.post("/api/v1/cliaminvite", {
        userid: Username,
        System: Systems,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          var decoded = jwt_decode(token);
          var Username = decoded.message.playerid;
          this.rechecklogin(Username, token);
          await Swal.fire({
            title: 'Success!',
            text: t(this.lang, 'invite_success'),
            icon: 'success',
            confirmButtonText: t(this.lang, 'ok')
          })

        }
        else if (res.data.status === 201) {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'invite_no_balance'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ok')
          })
          return false;
        }
        else if (res.data.status === 202) {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'action_failed'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ok')
          })
          return false;
        }

      }).catch(async (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ok')
          })
          window.location.href = '/';
        }
      });
    }
    else {
      await Swal.fire({
        title: 'error!',
        text: t(this.lang, 'not_logged_in'),
        icon: 'error',
        confirmButtonText: t(this.lang, 'ok')
      })
      return false;
    }
  }
  checktab(e, index) {

    this.setState({
      tabselect: index,
    });

  }
  notify = async (mode, msg) => {
    if (mode == "success") {
      await toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "warning") {
      await toast.warning(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "error") {
      await toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "info") {
      await toast.info(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    await this.waitnotify();
  }
  copyCode = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.notify("warning", 'CopyCode!!!');
      })
      .catch((err) => {
      });

  };
  async componentDidMount() {
    if (this.props.linelink) {
      this.setState({ linelink: this.props.linelink });
    } else {
      const data = this.context;
      if (data?.message) this.setState({ linelink: data.message[1].value });
    }

    this.getwheel();

    var token = localStorage.getItem('auth_token');
    if (this.props.username && token) {
      this.setState({
        loginstate: this.props.loginstate,
        username: this.props.username,
        userid: this.props.userid,
        balance: this.props.balance,
        point: this.props.point,
        rankpic: this.props.rankpic,
        rankname: this.props.rankname,
      });
      await this.rechecklogin(this.props.username, token);
      this.checkuseradvice(this.props.username);
    } else if (token != null) {
      try {
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await this.rechecklogin(Username, token);
        this.setState({
          userid: decoded.message.playerid,
          username: decoded.message.playerid,
          firstname: decoded.message.firstname,
          lastname: decoded.message.lastname,
          loginstate: true,
        });
        this.checkuseradvice(decoded.message.playerid);
      } catch (error) {}
    } else {
      this.setState({ loginstate: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loginstate !== this.props.loginstate ||
        prevProps.balance !== this.props.balance ||
        prevProps.point !== this.props.point) {
      if (this.props.loginstate && this.props.username) {
        this.setState({
          loginstate: this.props.loginstate,
          username: this.props.username,
          userid: this.props.userid,
          balance: this.props.balance,
          point: this.props.point,
          tblprofile: this.props.tblprofile,
          rankpic: this.props.rankpic,
          rankname: this.props.rankname,
          rankob: this.props.rankob,
          rankpoint: this.props.rankpoint,
          linkaff: this.props.linkaff,
          linelink: this.props.linelink || this.state.linelink,
        });
      }
    }
  }
  openAccout(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].className += " -open";
    }
  }
  async checkuseradvice(username) {

    instance.post("/api/v1/checkuseradvice", {
      User_id: username,
      page: 1,
      System: Systems,
    }).then((res) => {
      if (res.data.status === 200) {
        this.setState({
          useradvice: res.data.message.useradvicelist
        });
      }
      else {
      }
    });
  }

  cancelredeempromotion = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: t(this.lang, 'cancel_promo_confirm'),
        showCancelButton: true,
        confirmButtonText: t(this.lang, 'ok'),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          await instance.post("/api/v1/usercancelpromotion", {
            User_id: Username,
            System: Systems,
            no: index.no,
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              this.checkpro(null, 999);
              Swal.fire(t(this.lang, 'process_success'), '', 'success')
            }
            else {
              Swal.fire(t(this.lang, 'action_failed_wait'), '', 'error')
            }
          });

        }
      })
    }

  }

  openAccoutcan(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].className = "x-menu-account-list-sidebar";
    }
  }

  async rechecklogin(Username, token) {

    try {
      const search = window.location.href;
      const paramx = new URLSearchParams(search);
      const space = window.location.host
      var userhash = md5(Username);
      const linkaff = "https://" + space + "/register?reg=" + userhash;
      instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'rechecklogin-navbar.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          localStorage.setItem('auth_token', res.data.token)
          this.setState({
            rankpic: res.data.tblrank?.image,
            rankname: res.data.tblrank?.name,
            linkaff: linkaff,
            rankob: res.data.tblrank,
            rankpoint: res.data.rankpoint,
            remaining_amount: res.data.message.remaining_amount,
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            tblprofile: res.data.message,
            username: res.data.message.playerid,
            fname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
        }
        else if (res.data.status === 401) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ok')
          })
          window.location.href = '/';
        }

      }).catch(async (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ok')
          })
          window.location.href = '/';
        }
      });
    }
    catch (ex) {
    }

  }
  checkpro = async (e, proid) => {
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/checkpromotion", {
      userid: Username,
      System: Systems,
      Proid: proid,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        if (res.data.type === 0) {
          this.setState({
            prodetail: res.data.message.tblpromotions,
          });
        }
        else if (res.data.type === 1) {
          this.setState({
            proderedeemlist: res.data.message.tblpromotionredeems,
          });

        }

      }
      else if (res.data.status === 201) {
        await Swal.fire({
          title: 'error!',
          text: t(this.lang, 'promo_not_eligible'),
          icon: 'error',
          confirmButtonText: t(this.lang, 'ok')
        })
        return false;
      }
      else if (res.data.status === 202) {
        await Swal.fire({
          title: 'error!',
          text: t(this.lang, 'promo_pending_deposit'),
          icon: 'error',
          confirmButtonText: t(this.lang, 'ok')
        })
        return false;
      }

    }).catch(async (err) => {
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: 'Warning!',
          text: t(this.lang, 'session_expired'),
          icon: 'warning',
          confirmButtonText: t(this.lang, 'ok')
        })
        window.location.href = '/';
      }
    });
  }

  validateLogout = (e) => {
    localStorage.removeItem('auth_token', '')
    this.setState({
      userid: null,
      username: null,
      password: null,
      firstname: null,
      lastname: null,
      point: null,
      loginstate: false,
    });
  }
  async recheccredit(evt) {

    evt.currentTarget.className += " fa-spin";
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    this.setState({
      userid: decoded.message.playerid,
      username: decoded.message.playerid,
      firstname: decoded.message.firstname,
      lastname: decoded.message.lastname,
      loginstate: true,
    });
    try {
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'recheccredit-navbar.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          localStorage.setItem('auth_token', res.data.token)
          this.setState({
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
          var i, tablinks;
          tablinks = document.getElementsByClassName("-btn-balance");
          for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
          }
        }
        else if (res.data.status === 401) {
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ok')
          })
        }

      }).catch(async (err) => {
      });
    }
    catch (ex) {
    }
  }
  logout = (e) => {
    let errors = this.validateLogout();
    if (errors === true) {
      window.location.reload()
    } else {

      this.setState({
        errors: errors,
        formSubmitted: true
      });
      window.location.reload()
    }
  }
  getwheel = async () => {
    const cacheKey = "wheelSpinCache";
    const cacheTTL = 10 * 60 * 1000;
    const cachedData = JSON.parse(localStorage.getItem(cacheKey));

    if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
      this.setState({
        tblwheelsetting: cachedData.data.tblwheelsetting,
        segments: cachedData.data.segments,
        segColors: cachedData.data.segColors,
      });
      return;
    }

    try {
      const res = await instance.post("/api/v1/getwheelspin", {
        System: Systems,
      });

      if (res.data.status === 200) {
        const datas = res.data.message;
        const segments = [];
        const segColors = [];

        for (let i = 0; i < datas.length; i++) {
          const { id, description: name, color, image } = datas[i];
          segments.push({ id, name, image });
          segColors.push(color);
        }

        const newData = {
          tblwheelsetting: res.data.tblwheelsetting,
          segments,
          segColors,
        };

        this.setState(newData);

        localStorage.setItem(cacheKey, JSON.stringify({
          timestamp: Date.now(),
          data: newData,
        }));

      } else {
      }
    } catch (error) {
    }
  };

  render() {
    const lang = this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
    const { loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile } = this.state
    return (
      <>
        <br></br>
        <br></br>
        <br></br>
        <div className="-full-flex-wrap ">
          <div className="-full-flex-inner-bg -bg" style={{ backgroundImage: 'url(/build/web/igame-index-lobby-wm/img/index-bg.jpg?v=1)' }}>
            <div className="x-lucky-wheel-share-component  x-bg-position-center lazyloaded" data-bgset="/build/web/igame-index-lobby-wm/img/wheel-page-bg.jpg?v=1" style={{ backgroundImage: 'url("/build/web/igame-index-lobby-wm/img/wheel-page-bg.jpg?v=1")' }}>
              <div className="container position-relative">
                <div class="-btn-info-wrapper animated fadeInUp" data-animatable="fadeInUp">
                  <button
                    className="btn -btn-info"
                    data-toggle="modal"
                    data-target="#luckyWheelConditionModal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 13A6 6 0 1 1 8 2a6 6 0 0 1 0 12z" />
                      <path d="M7.25 4.5a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0zM8 6c-.69 0-1.25.56-1.25 1.25v3a.75.75 0 1 0 1.5 0v-3c0-.41-.34-.75-.75-.75z" />
                    </svg>
                  </button>
                </div>

              </div>
              <div className="text-center mb-4">
                <h1 className="-heading-title animated fadeInUp" data-animatable="fadeInUp">{t(lang,'lucky_wheel_title')}</h1>
              </div>
              <div className="container">
                <div id="wheel" data-animatable="fadeInUp" data-delay={250} className="x-wheel-container x-bg-position-center lazyloaded animated fadeInUp" data-bgset="/images/cloudigame/wheel-bg.png" style={{ backgroundImage: 'url("/images/cloudigame/wheel-bg.png")' }}>
                  <img alt="Website name Image" className="-wheel-ring" width={528} height={528} src="/images/cloudigame/wheel-ring.png" />
                  <div className="-center-pin">
                    <img alt="Website name Image" className="-wheel-pin" width={112} height={171} src="/images/cloudigame/wheel-pin.png" />
                    <img src alt={t(lang, 'lucky_wheel_alt')} id="rewardImgCenter" className="-reward-img" />
                  </div>
                  {(this.state.segments === null || this.state.segments.length == 0) ? "" :
                    <div className={"x-wheel-inner-wrapper -length-" + (this.state.segments.length)} style={{ "--wheel-length": (this.state.segments.length) }} >
                      <div id="wheelSpinner" className="-spinner">
                        {this.state.segments.map((listitem, i) => (
                          <div key={listitem.id || i} id={"wheelRewardKey_" + listitem.id} className={"-wheel-section whell" + listitem.id}  >
                            <div className="-wheel-content-wrapper">
                              <div className="-text">{listitem.name}</div>
                              <img src={listitem.image} className="-img" alt={t(lang, 'lucky_wheel_alt')} width={30} height={30} />
                            </div>
                          </div>

                        ))}
                      </div>
                    </div>
                  }

                </div >
                <button className={this.state.point > 0 ? "btn -btn-spin js-wheel-button animated fadeInUp" : "btn -btn-spin js-wheel-button disabled animated fadeInUp"} data-animatable="fadeInUp" data-delay={200} disabled={this.state.point <= 0}>
                  <span className="-text ">{t(lang,'spin_wheel_btn')}</span>
                  <img alt="Website name Image" className="img-fluid" width={30} height={30} src="/images/cloudigame/wheel-ticket.png" />
                  <span className="-text js-spin-ticket">{this.state.point}</span>
                </button>
                <audio id="sfx-wheel-spinning" src="/audio/cloudigame/sfx-wheel-spinning.mp3" />
                <audio id="sfx-wheel-got-reward" src="/audio/cloudigame/sfx-wheel-got-reward.mp3" />
              </div >
              <div className="x-wheel-progress-wrapper">
                <div className="container">
                  <div className="-inner-wrapper animated fadeInUp" data-animatable="fadeInUp">
                    <div>{this.state.tblwheelsetting.length > 0 ? this.state.tblwheelsetting[0].description : ""}</div>
                    <div className="progress -progress mt-2">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width:
                            this.state.tblwheelsetting.length > 0 && this.state.tblwheelsetting[0].amount > 0
                              ? (this.state.remaining_amount / this.state.tblwheelsetting[0].amount) * 100 + '%'
                              : '0%',
                        }}
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />

                      {/* <div className="progress-bar -progress-bar" role="progressbar" style={{ width: (this.state.remaining_amount-this.state.tblwheelsetting[0].amount ) +'%' }} aria-valuenow={0} aria-valuemin={0} aria-valuemax={100} /> */}
                      <span className="-label">{this.state.remaining_amount}/{this.state.tblwheelsetting.length > 0 ? this.state.tblwheelsetting[0].amount : 0} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div >
            <div className="x-modal modal" id="luckyWheelConditionModal"  tabIndex={-1} role="dialog" aria-hidden="true" >
              <div className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-medium" role="document">
                <div className="modal-content -modal-content">
                  <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                      />
                    </svg>
                  </button>
                  <div className="modal-header -modal-header">
                    <h3 className="x-title-modal d-inline-block m-auto">
                      {t(lang, 'wheel_conditions_title')}                          </h3>
                  </div>
                  <div className="modal-body -modal-body">
                    <div className="x-lucky-wheel-condition-container">
                      <p>{t(lang, 'wheel_cond_deposit')}<br />
                        {t(lang, 'wheel_cond_reset_prefix')} <span style={{ color: '#f39c12' }}><u><strong>{t(lang, 'wheel_cond_reset_value')}</strong></u></span> {t(lang, 'wheel_cond_reset_suffix')}</p>
                      <p><span style={{ color: '#e74c3c' }}>{t(lang, 'wheel_cond_ticket_note')} </span></p>
                      <p><span style={{ color: '#e74c3c' }}>
                        {t(lang, 'wheel_cond_no_entry')}</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
        </div >
      </>
    );
  }
}
export default App;

